// Tenor API integration for GIF search
// Get your API key from https://tenor.com/gifapi

const TENOR_API_KEY = process.env.REACT_APP_TENOR_API_KEY || 'AIzaSyAyimkuYQYF_FXVALexPuGQctUWRURdCYQ'; // Public test key
const TENOR_API_URL = 'https://tenor.googleapis.com/v2';

/**
 * Fetch trending GIFs from Tenor
 * @param {number} limit - Number of results to fetch (default: 20)
 * @returns {Promise<Array>} Array of GIF objects
 */
export async function fetchTrendingGifs(limit = 20) {
  try {
    const response = await fetch(
      `${TENOR_API_URL}/featured?key=${TENOR_API_KEY}&client_key=tchat&limit=${limit}&media_filter=gif,tinygif`
    );
    
    if (!response.ok) {
      throw new Error(`Tenor API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.results || [];
  } catch (error) {
    console.error('Error fetching trending GIFs:', error);
    return [];
  }
}

/**
 * Search GIFs on Tenor
 * @param {string} query - Search query
 * @param {number} limit - Number of results to fetch (default: 20)
 * @returns {Promise<Array>} Array of GIF objects
 */
export async function searchGifs(query, limit = 20) {
  if (!query || query.trim().length === 0) {
    return fetchTrendingGifs(limit);
  }
  
  try {
    const response = await fetch(
      `${TENOR_API_URL}/search?key=${TENOR_API_KEY}&client_key=tchat&q=${encodeURIComponent(query)}&limit=${limit}&media_filter=gif,tinygif`
    );
    
    if (!response.ok) {
      throw new Error(`Tenor API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.results || [];
  } catch (error) {
    console.error('Error searching GIFs:', error);
    return [];
  }
}

/**
 * Get GIF categories from Tenor
 * @returns {Promise<Array>} Array of category objects
 */
export async function fetchGifCategories() {
  try {
    const response = await fetch(
      `${TENOR_API_URL}/categories?key=${TENOR_API_KEY}&client_key=tchat`
    );
    
    if (!response.ok) {
      throw new Error(`Tenor API error: ${response.status}`);
    }
    
    const data = await response.json();
    return data.tags || [];
  } catch (error) {
    console.error('Error fetching GIF categories:', error);
    return [];
  }
}

/**
 * Get the best quality GIF URL from a Tenor GIF object
 * @param {Object} gif - Tenor GIF object
 * @returns {string} GIF URL
 */
export function getGifUrl(gif) {
  // Try to get the best quality GIF
  return gif?.media_formats?.gif?.url || 
         gif?.media_formats?.tinygif?.url || 
         gif?.url || 
         '';
}

/**
 * Get a preview/thumbnail URL from a Tenor GIF object
 * @param {Object} gif - Tenor GIF object
 * @returns {string} Preview URL
 */
export function getGifPreviewUrl(gif) {
  // Use tinygif for preview to save bandwidth
  return gif?.media_formats?.tinygif?.url || 
         gif?.media_formats?.nanogif?.url ||
         gif?.media_formats?.gif?.url || 
         '';
}

